<template>
  <div class="social-media">
    <div class="social-media-wrap">
      <div class="social-media-box">
        <a href="https://www.youtube.com/user/pbf12345/featured" rel="noreferrer noopener" target="_blank">
          <img class="social-media-box__icon social-media-box__icon--yt" src="@/assets/img/global/icon_yt.svg" />
        </a>
        <div class="social-media-box__desc">
          <p class="social-media-box__desc__text">更多影音在</p>
          <p class="social-media-box__desc__text">YouTube頻道</p>
        </div>
      </div>
      <div class="social-media-box">
        <a href="https://www.facebook.com/pbf.org.tw/" rel="noreferrer noopener" target="_blank">
          <img class="social-media-box__icon social-media-box__icon--fb" src="@/assets/img/global/icon_fb.svg" />
        </a>
        <div class="social-media-box__desc">
          <p class="social-media-box__desc__text">粉絲團按讀</p>
          <p class="social-media-box__desc__text">為小腳丫集氣!</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SocialMedia',
  components: {},
});
</script>
<style lang="scss" scoped>
@import '~@/styles/utils/_rwd.scss';
.social-media {
  // @include flex();
  position: relative;
  z-index: 1000;
}

.social-media-wrap {
  @include flex(center);
}
.social-media-box {
  @include flex();

  & + & {
    margin-left: 28px;
  }

  &__icon {
    cursor: pointer;

    &--yt {
      width: 40px;
    }

    &--fb {
      width: 34px;
    }
  }

  &__desc {

    margin-left: 8px;

    &__text {
      @include font-style($c-white, $f-footer, 400, 1.4px, 20px);
    }
  }
}

@media screen and (min-width: $tablet) {
  .social-media-wrap {
    @include flex(flex-start);
  }
}
</style>
